var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsuario(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4398_70600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.928711 18.9113V17.0065C0.928711 15.9961 1.32004 15.0272 2.0166 14.3128C2.71316 13.5983 3.65791 13.197 4.643 13.197H8.35728C9.34237 13.197 10.2871 13.5983 10.9837 14.3128C11.6802 15.0272 12.0716 15.9961 12.0716 17.0065V18.9113M2.78585 5.57793C2.78585 6.58827 3.17718 7.55724 3.87374 8.27167C4.57031 8.98609 5.51505 9.38745 6.50014 9.38745C7.48523 9.38745 8.42997 8.98609 9.12654 8.27167C9.8231 7.55724 10.2144 6.58827 10.2144 5.57793C10.2144 4.56758 9.8231 3.59861 9.12654 2.88419C8.42997 2.16976 7.48523 1.7684 6.50014 1.7684C5.51505 1.7684 4.57031 2.16976 3.87374 2.88419C3.17718 3.59861 2.78585 4.56758 2.78585 5.57793Z",
    stroke: "#4E4E4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4398_70600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsuario);
export default __webpack_public_path__ + "static/media/usuario.aa57d241d6dd35ebb58607caa1b3532c.svg";
export { ForwardRef as ReactComponent };